import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const TabContainer = styled.div`
  min-width: 162px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  flex-direction: column;
  cursor: pointer;
  ${({ isSelected }) => {
    return isSelected
      ? css`
          background-color: ${select('neutralGray')};
        `
      : css`
          color: ${select('midDarkGrayAux')};
        `;
  }}
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const SelectedMarker = styled.div`
  background-color: ${select('orange')};
  width: 84%;
  height: 2px;
`;

export { TabContainer, TabsContainer, SelectedMarker };
